/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { StringAnyMap } from 'src/app/core/models/common.models';
import { BaseSingleSelectComponent } from '../craft-single-select/craft-single-select.component';

@Component({
  selector: 'craft-color-selector',
  templateUrl: './craft-color-selector.component.html',
  styleUrls: ['./craft-color-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftColorSelectorComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftColorSelectorComponent extends BaseSingleSelectComponent implements OnChanges {
  @Input() public items: Readonly<StringAnyMap>;

  constructor(protected cdRef: ChangeDetectorRef) {
    super(cdRef);
  }

  public ngOnChanges() {
    // override: do nothing
  }

  public changeSelectedItem(color: string) {
    if (!this.unselectMode || this.selectedId !== color) {
      this.selectedId = color;
      this.selectedItem = color;
      this.select.next(color);
    } else if (this.selectedId === color) {
      this.selectedId = void 0;
      this.selectedItem = void 0;
      this.unselect.next(color);
    }
  }

  public identify(index: number, item: any): string | number {
    return item?.key || index;
  }
}
